import { api } from './client';

export interface MovieListItem {
  id: string;
  kind: 'movie';
  title: string;
  year: number | null;
  durationSec: number | null;
  status: 'awaiting_upload' | 'queued' | 'transcoding' | 'ready' | 'failed';
  posterUrl: string | null;
  tmdbId: number | null;
}

export interface MovieDetail extends MovieListItem {
  overview: string | null;
  hls: { masterKey: string; renditions: string[] } | null;
}

export async function listMovies() {
  return api.get<{ items: MovieListItem[] }>('/api/library/movies');
}

export async function getMovie(id: string) {
  return api.get<MovieDetail>(`/api/library/movies/${id}`);
}
